"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanetFederation = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const OrOptions_1 = require("../../../inputs/OrOptions");
const SelectOption_1 = require("../../../inputs/SelectOption");
class PlanetFederation {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.PLANET_FEDERATION;
        this.description = 'Gain 3 steel, 2 titanium or 5 M€ if you have at least 5 planetary tags. Influence counts as planetary tags.';
        this.revealedDelegate = PartyName_1.PartyName.CENTRISTS;
        this.currentDelegate = PartyName_1.PartyName.EMPOWER;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const planetaryTagCount = player.getTagCount(Tags_1.Tags.VENUS, 'raw') + player.getTagCount(Tags_1.Tags.EARTH, 'raw') + player.getTagCount(Tags_1.Tags.JOVIAN, 'raw');
            if (planetaryTagCount + turmoil.getPlayerInfluence(player) >= 5) {
                const gainSteel = new SelectOption_1.SelectOption('Gain 3 steel', 'Select', () => {
                    player.addResource(Resources_1.Resources.STEEL, 3, { log: true });
                    return undefined;
                });
                const gainTitanium = new SelectOption_1.SelectOption('Gain 2 titanium', 'Select', () => {
                    player.addResource(Resources_1.Resources.TITANIUM, 2, { log: true });
                    return undefined;
                });
                const gainMc = new SelectOption_1.SelectOption('Gain 5 M€', 'Select', () => {
                    player.addResource(Resources_1.Resources.MEGACREDITS, 5, { log: true });
                    return undefined;
                });
                game.defer(new DeferredAction_1.DeferredAction(player, () => new OrOptions_1.OrOptions(gainTitanium, gainSteel, gainMc)));
            }
        });
    }
}
exports.PlanetFederation = PlanetFederation;
//# sourceMappingURL=PlanetFederation.js.map